import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import * as moment from 'moment/moment';
import { Subscription } from 'rxjs/internal/Subscription';
import { AppointmentsTurnsService } from 'src/app/services/turns-services/appointments-turns-service/appointment-turns.service';
import { tap } from 'rxjs/operators';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { Json2csvService } from 'csvtools-lib';
import { DateUnixTransformerPipe } from 'src/app/pipes/date-unix-transformer-pipe/date-unix-transformer.pipe';

@Component({
  selector: 'app-turns-appointments-filter-appointments-card',
  templateUrl: './turns-appointments-filter-appointments-card.component.html',
  styleUrls: ['./turns-appointments-filter-appointments-card.component.scss']
})
export class TurnsAppointmentsFilterAppointmentsCardComponent implements OnInit, OnDestroy {

  @Input() data;
  show: boolean;
  centerList;
  formList;
  deskList;
  refreshing: boolean;
  searchAppointmentsListSubscription: Subscription;
  getFormsSubscription: Subscription;
  getDesksSubscription: Subscription;
  getDailyAppointmentsSubscription: Subscription;
  filterAppointmentsForm = new FormGroup({
    dateFrom: new FormControl(),
    dateTo: new FormControl(),
    timeFrom: new FormControl(),
    timeTo: new FormControl(),
    selectedCentersList: new FormControl(),
    selectedFormsList: new FormControl(),
    selectedDesksList: new FormControl(),
    checkedAppointments: new FormControl('')
  });

  constructor(private userStorageService: UserStorageService,
              private snackbarService: SnackBarService,
              private json2csvService: Json2csvService,
              private dateUnixTrannsformerPipe: DateUnixTransformerPipe,
              private appointmentsTurnsService: AppointmentsTurnsService) { }

  ngOnInit() {
    this.appointmentsTurnsService.listenRefreshAppointmentsSearch().pipe(
      tap(res => this.search())
    ).subscribe();
    this.centerList = this.userStorageService.getCenterList();
    this.getForms();
    this.getDesks();
  }

  public showFilter() {
    this.show = !this.show;
  }

  public search() {
    const dateFrom = this.filterAppointmentsForm.get('dateFrom').value ? this.filterAppointmentsForm.get('dateFrom').value.valueOf() : null;
    const dateTo = this.filterAppointmentsForm.get('dateTo').value ? this.filterAppointmentsForm.get('dateTo').value.valueOf() : null;
    const timeFrom = (moment(this.filterAppointmentsForm.get('timeFrom').value, 'hh:mm').hour() * 3600000) + (moment(this.filterAppointmentsForm.get('timeFrom').value, 'hh:mm').minutes() * 60000);
    const timeTo = (moment(this.filterAppointmentsForm.get('timeTo').value, 'hh:mm').hour() * 3600000) + (moment(this.filterAppointmentsForm.get('timeTo').value, 'hh:mm').minutes() * 60000);
    const from = timeFrom ? dateFrom + timeFrom : dateFrom;
    const to = timeTo ? dateTo + timeTo : dateTo + (23 * 3600000) + (59 * 60000) + (59 * 1000);
    const appointmentsChecked = this.filterAppointmentsForm.get('checkedAppointments').value === '' ? null : this.filterAppointmentsForm.get('checkedAppointments').value;
    this.searchAppointmentsListSubscription = this.appointmentsTurnsService.getTurnsAppointments(from, to, this.mapCentersIds(this.filterAppointmentsForm.get('selectedCentersList').value), this.mapFormsIds(this.filterAppointmentsForm.get('selectedFormsList').value), this.mapDesksIds(this.filterAppointmentsForm.get('selectedDesksList').value), appointmentsChecked).pipe(
      tap(res => this.appointmentsTurnsService.refreshAppointmentsList(res)),
      tap(res => this.refreshing = false)
    ).subscribe();
  }

  public refresh() {
    this.refreshing = true;
    if (this.filterAppointmentsForm.get('dateFrom').value || this.filterAppointmentsForm.get('dateTo').value) {
      this.search();
    } else {
      const todayFrom = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0).getTime();
      const todayTo = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59.999).getTime();
      const centerInternalIdList = this.userStorageService.getCenterList().map( center => center.InternalId );
      this.getDailyAppointmentsSubscription = this.appointmentsTurnsService.getTurnsAppointments(todayFrom, todayTo, centerInternalIdList, null, null, null).subscribe(
        (res) => {
          this.appointmentsTurnsService.refreshAppointmentsList(res);
          this.refreshing = false;
        },
        (error) => {
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
    }
  }

  public centersOutputEventReceiver(centers) {
    const aux = new Array();
    for (const c of centers) {
      aux.push(c[1]._data);
    }
    this.filterAppointmentsForm.get('selectedCentersList').setValue(aux);
  }

  public formsOutputEventReceiver(forms) {
    const aux = new Array();
    for (const c of forms) {
      aux.push(c[1]._data);
    }
    this.filterAppointmentsForm.get('selectedFormsList').setValue(aux);
  }

  public desksOutputEventReceiver(desks) {
    const aux = new Array();
    for (const c of desks) {
      aux.push(c[1]._data);
    }
    this.filterAppointmentsForm.get('selectedDesksList').setValue(aux);
  }

  public mapCentersIds(centers) {
    if (centers && (centers.length > 0)) {
      return centers.map((center) => center.InternalId);
    }
  }

  public mapFormsIds(forms) {
    if (forms && (forms.length > 0)) {
      return forms.map((form) => form.InternalId);
    }
  }

  public mapDesksIds(desks) {
    if (desks && (desks.length > 0)) {
      return desks.map((desk) => desk.InternalId);
    }
  }

  private getForms() {
    this.getFormsSubscription = this.appointmentsTurnsService.getForms().subscribe(
      (res) => {
        if (res) {
          this.formList = res;
        }
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getDesks() {
    this.getDesksSubscription = this.appointmentsTurnsService.getDesks().subscribe(
      (res) => {
        this.deskList = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public clearField(fieldName) {
    this.filterAppointmentsForm.patchValue({
      [fieldName]: null
    });
  }

  public generateCSV() {
    this.data.forEach(i => i['creationDate'] = this.dateUnixTrannsformerPipe.transform(i['creationDate']));
    this.data.forEach(i => i['appointmentDate'] = this.dateUnixTrannsformerPipe.transform(i['appointmentDate']));
    this.json2csvService.setBody(this.data, ['creationDate', 'turnFormName', 'turnDeskName', 'userDni', 'userMail', 'userName', 'userSurname', 'userTelephone', 'userLicensePlate', 'userPassport', 'userCard', 'userDocumentUrl', 'appointmentToken', 'appointmentDate']);
    this.json2csvService.setHeader(['Created', 'Form', 'Attention', 'DNI', 'Mail', 'Name', 'Surname', 'Telephone', 'License plate', 'Passport', 'Card', 'DocumentUrl', 'Token', 'Appointment date']);
    this.json2csvService.generateCSV('appointments');
  }

  ngOnDestroy() {
    if (this.searchAppointmentsListSubscription) { this.searchAppointmentsListSubscription.unsubscribe(); }
    if (this.getFormsSubscription) { this.getFormsSubscription.unsubscribe(); }
    if (this.getDesksSubscription) { this.getDesksSubscription.unsubscribe(); }
    if (this.getDailyAppointmentsSubscription) { this.getDailyAppointmentsSubscription.unsubscribe(); }
  }
}
